<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import raiseElbow from '@/assets/animations/raise_elbow.json';

export default {
  name: 'RaiseElbow',
  mixins: [animation],
  data: () => ({
    animationData: raiseElbow,
    autoPlay: true,
  }),
};
</script>

<style lang="scss" scoped>
@mixin mini {
  @apply mx-auto;
  transform: scale(1.275) translateY(2px);
  min-height: 290px;
  max-height: 290px;
}
%mini {
  @include mini;
}
.animation {
  @apply relative flex justify-center items-center my-auto;
  width: 50%;
  max-width: 193px;
  min-width: 193px;
  height: 100%;
  max-height: 505px;
  min-height: 505px;
  &.mini {
    @extend %mini;
  }
  @screen xs {
    @include mini;
    .animation {
      top: 21%;
    }
  }

  transform: scale(2.125) translateY(2px);
}
</style>
